import moment from 'moment';

export const isTokenValid = (created: string, ttl: number): boolean => {
  if (!created || ttl === undefined) {
    return false;
  }

  // date time of current moment
  const now = moment();
  // Add time to live to current moment. Also subtract 2 hours.
  // This is to be sure that we are earlier than the server time, to be sure that the token didnt expire already
  const validUntil = moment(created)
    .add(ttl, 'seconds')
    .subtract(2, 'hours');

  return validUntil.isAfter(now);
};
